export const TEXT_DATA_KEY = "textData";
export const PICTURE_DATA_KEY = "pictureData";
export const VIDEO_DATA_KEY = "videoData";
